import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
// import Products from "./pages/Products"; // <- removed since the page is deleted
import Services from "./pages/Services";
import Corporate from "./pages/Corporate";
import Installation from "./pages/Installation";
import Pricing from "./pages/Pricing";
import Blog from "./pages/Blog";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Dashboard from "./pages/Dashboard";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

export default function AppRoutes() {
  return (
    <Router>
      <ScrollToTop />   {/* <- MUST be inside <Router> */}
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/products" element={<Products />} /> */}
        <Route path="/services" element={<Services />} />
        <Route path="/corporate" element={<Corporate />} />
        <Route path="/installation" element={<Installation />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>

      <Footer />
    </Router>
  );
}
